import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../../resources/styles.scss';
import { authenticationService } from '../../services/authenticationService.js';
import { withTranslation } from 'react-i18next';
import MediaQuery from 'react-responsive';
import LanguageMenu from '../languageSelector/languageSelector'
import ModuleAccess from '../access/module_access';
import { AccessLevel, AppModules } from '../../constants/appAccess';
import { withRouter } from "react-router";
import { AdministrationMenu, MenuItem, RightMenu } from './styled';


const Header = (props) => {
    const { t, history } = props;
    const [isPopupMenuOpen, setIsPopupMenuOpen] = useState(false);

    useEffect(() => {
        document.addEventListener('touchend', resetMenu);
        return document.removeEventListener('touchend', resetMenu);
    }, [])

    const handleBlur = (event) => {
        // if the blur was because of outside focus
        // currentTarget is the parent element, relatedTarget is the clicked element
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setIsPopupMenuOpen(false);
        }
    }


    const logout = () => {
        authenticationService.logout();
        history.push('/login');
    }

    const toggleMobileMenu = () => {
        setIsPopupMenuOpen(!isPopupMenuOpen);
    }

    const resetMenu = (e) => {
        if (e.target.matches('.header_menu') || e.target.matches('.menu_popup') || e.target.matches('a')) {
            return;
        }

        setIsPopupMenuOpen(false);
    }

    const renderPages = (toggleMenu = () => { }) => {
        return (
            <>
                <ul>
                    <ModuleAccess access={AccessLevel.Read} moduleName={AppModules.Cards}>
                        <li>
                            <NavLink onClick={toggleMenu} to="/cards" activeClassName='is-active'>{t("PagesNames.Cards")}</NavLink>
                        </li>
                    </ModuleAccess>
                    <li>
                        <NavLink onClick={toggleMenu} to="/operations" activeClassName='is-active'>{t("PagesNames.Operations")}</NavLink>
                    </li>
                    <li>
                        <NavLink onClick={toggleMenu} to="/tanks" activeClassName='is-active'>{t("PagesNames.Tanks")}</NavLink>
                    </li>
                    <li>
                        <NavLink onClick={toggleMenu} to="/limits" activeClassName='is-active'>{t("PagesNames.Limits")}</NavLink>
                    </li>
                    <ModuleAccess access={AccessLevel.Read} moduleName={AppModules.OrderHistory}>
                        <li>
                            <NavLink onClick={toggleMenu} to="/orderHistory" activeClassName='is-active'>{t("PagesNames.OrderHistory")}</NavLink>
                        </li>
                    </ModuleAccess>
                </ul>

                <MediaQuery minDeviceWidth={1224}>
                    <RightMenu>
                        <ModuleAccess access={AccessLevel.Write} moduleName={AppModules.Administration}>
                            <li>
                                <AdministrationMenu title={t("PagesNames.Administration")}>
                                    <MenuItem onClick={toggleMenu}>
                                        <NavLink to="/users" activeClassName='is-active'>{t("PagesNames.UserManagement")}</NavLink>
                                    </MenuItem>
                                    <MenuItem onClick={toggleMenu}>
                                        <NavLink to="/roles" activeClassName='is-active'>{t("PagesNames.RoleManagement")}</NavLink>
                                    </MenuItem>
                                </AdministrationMenu>
                            </li>
                        </ModuleAccess>
                        <li>
                            <a onClick={logout}>{t("Header.LogoutText")}</a>
                        </li>
                    </RightMenu>
                </MediaQuery>
                <MediaQuery maxDeviceWidth={1224}>
                    <ul>
                        <ModuleAccess access={AccessLevel.Write} moduleName={AppModules.Administration}>
                            <li>
                                <AdministrationMenu title={t("PagesNames.Administration")}>
                                    <MenuItem onClick={toggleMenu}>
                                        <NavLink to="/users" activeClassName='is-active'>{t("PagesNames.UserManagement")}</NavLink>
                                    </MenuItem>
                                    <MenuItem onClick={toggleMenu}>
                                        <NavLink to="/roles" activeClassName='is-active'>{t("PagesNames.RoleManagement")}</NavLink>
                                    </MenuItem>
                                </AdministrationMenu>
                            </li>
                        </ModuleAccess>
                        <li>
                            <a onClick={logout}>{t("Header.LogoutText")}</a>
                        </li>
                    </ul>
                </MediaQuery>

            </>
        );
    }

    const renderLaptopMenu = () => {
        return (
            <>
                <div className="header_menu">
                    {renderPages()}
                </div>
            </>
        );
    }

    const renderMobileMenu = () => {
        return (
            <div className={"header_menu"} tabIndex={0} onBlur={handleBlur}>
                <div className={isPopupMenuOpen ? "header_menu_icon active" : "header_menu_icon"} onClick={(toggleMobileMenu)}></div>
                <div className={isPopupMenuOpen ? "menu_popup opened" : "menu_popup closed"}>
                    {renderPages(() => setIsPopupMenuOpen(false))}
                </div>
            </div>
        );
    }

    return (
        <div className="app_header">
            <MediaQuery minDeviceWidth={1224}>
                {renderLaptopMenu()}
            </MediaQuery>
            <MediaQuery maxDeviceWidth={1224}>
                {renderMobileMenu()}
            </MediaQuery>
            <LanguageMenu position='absolute' top='0' bottom='0'></LanguageMenu>
        </div>
    );

}

export default withRouter(withTranslation('translations')(Header));